import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeItem } from '../../tree.model';
import { TreeComponent } from '../../tree/tree.component';

@Component({
  selector: 'app-editor-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule, TreeComponent],
  templateUrl: './editor-sidebar.component.html',
  styleUrl: './editor-sidebar.component.scss'
})
export class EditorSidebarComponent {
  @Input() sourceRoutes: TreeItem[] = [];
  @Input() metadata: any;
  @Input() selectedSourceComponentId: string | null = null;
  @Input() isDualPane = false;
  @Input() isTemplateMode = false;
  @Input() contentSearchResults: any[] = [];
  @Input() copySourceJsonState: 'idle' | 'success' = 'idle';

  @Output() contentSelected = new EventEmitter<any>();
  @Output() sidebarItemClicked = new EventEmitter<TreeItem>();
  @Output() orderChanged = new EventEmitter<void>();
  @Output() metadataPropertiesOpen = new EventEmitter<MouseEvent>();
  @Output() templateModeToggled = new EventEmitter<void>();
  @Output() contentSearchChanged = new EventEmitter<string>();
  @Output() importSourceClick = new EventEmitter<void>();
  @Output() copySourceJsonClick = new EventEmitter<void>();

  contentSearchTerm = '';
  showContentDropdown = false;

  onContentSearch(term: string) {
    this.contentSearchTerm = term;
    this.showContentDropdown = true;
    this.contentSearchChanged.emit(term);
  }

  selectContent(item: any) {
    this.contentSearchTerm = item.name || item.value;
    this.showContentDropdown = false;
    this.contentSelected.emit(item);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.showContentDropdown && !target.closest('.sidebar-search')) {
      this.showContentDropdown = false;
    }
  }
}
